// Import classifier for `@import` declarations and target path extraction.
// Supports `@import "x.css"` and `@import url("x.css")` forms.
import { normalizeImportPath } from './classify-path'
import { readImportBody } from './classify-readers'
import type { ParsedImportRequest } from './types'

// Check whether at-rule name maps to charset aliases.
export function isCharsetName(name: string): boolean {
  // Return true for supported charset aliases.
  return name === 'char' || name === 'charset'
}

// Parse import request path and classify it by extension kind.
export function parseImportRequest(statement: string): ParsedImportRequest | null {
  const importBody = readImportBody(statement)
  // Check whether the declaration contains a readable import request.
  if (!importBody) {
    // Return null for malformed import declarations without a source request.
    return null
  }

  const normalized = normalizeImportPath(importBody)
  // Check the normalized request extension after query and hash stripping.
  if (normalized.endsWith('.css')) {
    // Return the parsed CSS import request payload.
    return { raw: importBody, normalized, kind: 'css' }
  } else if (normalized.endsWith('.luis')) {
    // Return the parsed `.luis` import request payload.
    return { raw: importBody, normalized, kind: 'luis' }
  } else {
    // Return passthrough payload for unknown import target kinds.
    return { raw: importBody, normalized, kind: 'other' }
  }
}
